import {
  ICalendarState,
  initICalendarState,
} from '../states/aumye-calendar.state';
import * as fromCalendarActions from '../actions/calendar.actions';
import { Visitor } from 'src/app/models/visitor';
export function reducer(
  state = initICalendarState,
  action: fromCalendarActions.CyclopsCalendarActionUnion
): ICalendarState {
  switch (action.type) {
    case fromCalendarActions.CalendarActionTypes.RESET_STATE: {
      return initICalendarState;
    }
    case fromCalendarActions.CalendarActionTypes.INIT_VISITOR_CALENDAR: {
      const { payload } = action;
      return {
        ...state,
        flows: {
          ...state.flows,
          isVisitorCalendarTab: true,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: payload.visitorDetails.visitorList,
          totalUnverified: payload.visitorDetails.totalUnverified,
          totalVerified: payload.visitorDetails.totalVerified,
          totalVisitor: payload.visitorDetails.totalVisitor,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.GET_CALENDAR_DIMENSIONS: {
      const { payload } = action;
      return {
        ...state,
        style: {
          ...state.style,
          getCalendarHeight: payload.height,
          getCalendarWidth: payload.width,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.GET_TIME_SLOTS: {
      const { payload } = action;
      return {
        ...state,
        flows: {
          ...state.flows,
          isFetchingTimeSlots: true,
        },
        details: {
          ...state.details,
          todayDateFull: payload.todayDateFull,
          todayDate: payload.todayDate,
          todayDay: payload.todayDay,
          todayMonth: payload.todayMonth,
        },
        timeSlots: {
          ...state.timeSlots,
          list: state.timeSlots.list ? [...state.timeSlots.list] : [],
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.GET_TIME_SLOTS_SUCCESS: {
      const { payload } = action;
      const timeSlotList = state.timeSlots.list
        ? [...state.timeSlots.list, ...payload]
        : payload;
      return {
        ...state,
        flows: {
          ...state.flows,
          isFetchingTimeSlots: false,
        },
        status: {
          ...state.status,
          isTimeSlotsLoaded: true,
        },
        timeSlots: {
          ...state.timeSlots,
          list: timeSlotList,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.GET_TIME_SLOTS_FAILURE: {
      const { payload } = action;
      return {
        ...state,
        flows: {
          ...state.flows,
          isFetchingTimeSlots: false,
        },
        timeSlots: {
          ...state.timeSlots,
          Error: payload.global,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.GET_HOSTS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        userList: payload,
        status: {
          ...state.status,
          isUserListLoaded: true,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.SELECTED_DATE_TIME_SLOT: {
      const { payload } = action;
      return {
        ...state,
        visitorCalendarDetails: {
          ...state.visitorCalendarDetails,
          selectedDate: payload,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.INIT_VISITOR_INVITE: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isCreateNewVisitorFlow: true,
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes.CREATE_NEW_VISITOR_INVITE: {
      const {
        payload: {
          email,
          firstName,
          hostUserId,
          hostName,
          identityID,
          inviteCreateDate,
          inviteCreatedByUserID,
          lastName,
          carRegistration,
          orgID,
          phoneNumber,
          profilePicture,
          purpose,
          securityStatus,
          visitDateTime,
          visitorAddress,
          visitorID,
        },
      } = action;
      const newVisitor: Visitor = {
        email: email,
        firstName: firstName,
        hostUserId: hostUserId,
        hostName: hostName,
        identityID: identityID,
        inviteCreateDate: inviteCreateDate,
        inviteCreatedByUserID: inviteCreatedByUserID,
        lastName: lastName,
        carRegistration: carRegistration,
        orgID: orgID,
        phoneNumber: phoneNumber,
        profilePicture: profilePicture,
        purpose: purpose,
        securityStatus: securityStatus,
        visitDateTime: visitDateTime,
        visitorAddress: visitorAddress,
        visitorID: visitorID,
      };
      return {
        ...state,
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: [...state.visitorDetails.visitorList, newVisitor],
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes
      .CREATE_NEW_VISITOR_INVITE_SUCCESS: {
      const { payload } = action;
      let res = false;
      if (payload) {
        res = true;
      }
      return {
        ...state,
        status: {
          ...state.status,
          isVisitorCreateSuccess: res,
        },
        flows: {
          ...state.flows,
          isCreateNewVisitorFlow: false,
        },
        visitorDetails: {
          ...state.visitorDetails,
          visitorList: [...state.visitorDetails.visitorList],
        },
      };
    }
    case fromCalendarActions.CalendarActionTypes
      .CREATE_NEW_VISITOR_INVITE_FAILURE: {
      const { payload } = action;
      return {
        ...state,
        status: {
          ...state.status,
          isVisitorCreateSuccess: false,
          isError: true,
        },
        flows: {
          ...state.flows,
          isCreateNewVisitorFlow: false,
        },
        Error: payload.global,
      };
    }
    case fromCalendarActions.CalendarActionTypes.CANCEL_VISITOR_INVITE: {
      return {
        ...state,
        flows: {
          ...state.flows,
          isCreateNewVisitorFlow: false,
        },
      };
    }
  }

  return state;
}
